

export function throttle (context:any,fn: any, delay: number, mustRunDelay = 0) {
    let timer:any = null;
    let tStart:number = 0;
    return function():void {
        const args:any = arguments;
        const tCurr: number = new Date().getTime();
        clearTimeout(timer);
        if (tStart <= 0) {
            tStart = tCurr;
        }
        if (mustRunDelay !== 0 && tCurr - tStart >= mustRunDelay) {
            fn.apply(context, args);
            tStart = tCurr;
        } else {
            timer = setTimeout(function() {
                fn.apply(context, args);
            }, delay);
        }
    };
}